import { IState } from 'legacy/lut/store'

export const selectP360PartnerFlagsState = (state: IState) => state.partner360.p360PartnerFlags
